<div>
  <div class="search-box">
    <div>
      <span><b>Pesquisar por nome</b></span>
      <input [formControl]="nameControl" [(ngModel)]="filterText" type="text" autofocus (keyup.enter)="onPressEnterSearchClusters($event)" />
    </div>

    <div class="icon-container" (click)="searchClusters()">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>
</div>

<div *ngIf="hasResult()" class="quantities-container">
  <p class="result-quantity">{{ getResultQuantity() }}</p>
</div>
<div *ngIf="hasResult()" class="industry-list-container">
  <div *ngFor="let cluster of getClusters()" class="industry-card">
    <div class="industry-logo">
      <img src="./assets/icons/no-logo-company-icon.svg" />
    </div>
    <div class="industry-data">
      <div class="industry-card-header">
        <span class="industry-name" [matTooltip]="cluster.getName()">{{ cluster.getName() }}</span>
      </div>

      <div class="industry-data-container">
        <div class="data-container">
          <span class="data-value"><strong>Data: </strong>{{ cluster.getCreatedDate() }}</span>
        </div>
        <div class="data-container">
          <span class="data-value" *ngIf="cluster.getProductCount()"><strong>Produtos: </strong>{{ cluster.getProductCount() }}</span>

          <span class="data-value" *ngIf="!cluster.getProductCount()"><strong>Produtos: </strong>0</span>
        </div>
        <div class="data-container">
          <span class="data-value"><strong>Data da atualização: </strong>{{ cluster.getLastChangeDate() }}</span>
        </div>
      </div>
    </div>
    <div class="industry-status">
      <button mat-flat-button class="export-btn" (click)="exportClusterList(cluster)">
        <mat-icon aria-hidden="false" class="download-icon">file_download</mat-icon>
        <span>Exportar lista</span>
      </button>

      <button *ngIf="hasAccessToEditCluster()" mat-flat-button class="edit-btn" (click)="navigateToEdit(cluster)">
        <mat-icon aria-hidden="false">edit_note</mat-icon>
        <span>EDITAR</span>
      </button>
    </div>
  </div>
  <div class="more-btn-container" *ngIf="showMoreClustersBtn()">
    <a class="more-registers-btn" (click)="searchMoreClusters()">carregar mais registros</a>
  </div>
</div>
